export default __webpack_public_path__ + "2356124.png";